import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './TextEditorToolCaret.scss';

const TextEditorToolCaret = ({ isOpened, className }) => (
  <span
    className={cx(styles.arrow, className, {
      [styles.closed]: !isOpened,
      [styles.opened]: isOpened,
    })}
  />
);

TextEditorToolCaret.propTypes = {
  isOpened: PropTypes.bool,
  className: PropTypes.string,
};

export default TextEditorToolCaret;
